import React, { useEffect, useState } from 'react';
import Styles from './styles.module.scss';
import { ReactComponent as DeleteIcon } from '../../../../../assets/images/icon-checkedbox.svg';
interface ICustomCheckboxProps {
    checked: boolean;
    title: string;
    onChange: (selected: boolean) => void;
    dataComponentName?: string;
    disabled?: boolean;
}
export function CustomCheckbox({ checked, title, onChange, dataComponentName, disabled }: ICustomCheckboxProps) {
    const [Selected, setSelected] = useState<boolean>(false);
    useEffect(() => {
        setSelected(checked);
        // eslint-disable-next-line
    }, []);
    useEffect(() => {
        onChange(Selected);
        // eslint-disable-next-line
    }, [Selected]);
    return (
        <div
            data-checked={Selected}
            data-component-name={dataComponentName}
            onClick={disabled ? undefined : () => setSelected((prevState) => !prevState)}
            className={`
                ${Styles.CustomCheckboxDiv} ${Selected ? Styles.CustomCheckboxDivSelected : ''} ${
                disabled ? Styles.Disabled : ''
            }`}
        >
            <p>{title}</p>
            <div>
                <DeleteIcon width="18px" height="18px" />
            </div>
        </div>
    );
}
